// extracted by mini-css-extract-plugin
export default {"logs":"styles_logs__kZlaG","h2":"styles_h2__5dXRb"};